import Modal from '../../common/Modals/Modal';

const PhotoModalSave = ({ toggleShow, show, action, count }) => (
  <Modal
    className='modal'
    toggleShow={toggleShow}
    show={show}
    title={`Вы уверены, что хотите сохранить изменения?`}
    textBtnOk={'Сохранить'}
    btnOkAction={action}
    textBtnCancel={'Отмена'}
    open={show}
  ></Modal>
);
export default PhotoModalSave;
